export const ACTION_GROUP_GAP = 4;
